<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="500"
            min="0"
            :error="errors.waistPerimeter.length > 0"
            :error-messages="errors.waistPerimeter"
            v-model="form.waistPerimeter"
            :placeholder="$t('dashboard_new_evollu.measurement_types.waist_perimeter_short')+' (cm)'"
            :label="$t('dashboard_new_evollu.measurement_types.waist_perimeter_short')+' (cm)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="500"
          min="0"
          :error="errors.abdomenPerimeter.length > 0"
          :error-messages="errors.abdomenPerimeter"
          v-model="form.abdomenPerimeter"
          :placeholder="$t('dashboard_new_evollu.measurement_types.abdomen_perimeter_short')+' (cm)'"
          :label="$t('dashboard_new_evollu.measurement_types.abdomen_perimeter_short')+' (cm)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="500"
          min="0"
          :error="errors.chestPerimeter.length > 0"
          :error-messages="errors.chestPerimeter"
          v-model="form.chestPerimeter"
          :placeholder="$t('dashboard_new_evollu.measurement_types.chest_perimeter_short')+' (cm)'"
          :label="$t('dashboard_new_evollu.measurement_types.chest_perimeter_short')+' (cm)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="500"
          min="0"
          :error="errors.relaxedArmPerimeter.length > 0"
          :error-messages="errors.relaxedArmPerimeter"
          v-model="form.relaxedArmPerimeter"
          :placeholder="$t('dashboard_new_evollu.measurement_types.relaxed_arm_perimeter_short')+' (cm)'"
          :label="$t('dashboard_new_evollu.measurement_types.relaxed_arm_perimeter_short')+' (cm)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="500"
          min="0"
          :error="errors.thighPerimeter.length > 0"
          :error-messages="errors.thighPerimeter"
          v-model="form.thighPerimeter"
          :placeholder="$t('dashboard_new_evollu.measurement_types.thigh_perimeter_short')+' (cm)'"
          :label="$t('dashboard_new_evollu.measurement_types.thigh_perimeter_short')+' (cm)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="500"
          min="0"
          :error="errors.calfPerimeter.length > 0"
          :error-messages="errors.calfPerimeter"
          v-model="form.calfPerimeter"
          :placeholder="$t('dashboard_new_evollu.measurement_types.calf_perimeter_short')+' (cm)'"
          :label="$t('dashboard_new_evollu.measurement_types.calf_perimeter_short')+' (cm)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
const WAIST_PERIMETER_TYPE_ID = 69
const ABDOMEN_PERIMETER_TYPE_ID = 70
const CHEST_PERIMETER_TYPE_ID = 71
const RELAXED_ARM_PERIMETER_TYPE_ID = 72
const THIGH_PERIMETER_TYPE_ID = 73
const CALF_PERIMETER_TYPE_ID = 74

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        waistPerimeter: null,
        abdomenPerimeter: null,
        chestPerimeter: null,
        relaxedArmPerimeter: null,
        thighPerimeter: null,
        calfPerimeter: null
      },
      errors: {
        waistPerimeter: [],
        abdomenPerimeter: [],
        chestPerimeter: [],
        relaxedArmPerimeter: [],
        thighPerimeter: [],
        calfPerimeter: []
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 21
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.waistPerimeter !== null && this.form.waistPerimeter !== '') &&
        (this.form.abdomenPerimeter !== null && this.form.abdomenPerimeter !== '') &&
        (this.form.chestPerimeter !== null && this.form.chestPerimeter !== '') &&
        (this.form.relaxedArmPerimeter !== null && this.form.relaxedArmPerimeter !== '') &&
        (this.form.thighPerimeter !== null && this.form.thighPerimeter !== '') &&
        (this.form.calfPerimeter !== null && this.form.calfPerimeter !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.waistPerimeter": function(value) {
        if(value !== '' && (value < 1 || value > 500)) {
          this.errors.waistPerimeter = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
        }
        else {
          this.errors.waistPerimeter = []
        }

        if(this.measurement.measurements.find(meas => meas.typeId === WAIST_PERIMETER_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === WAIST_PERIMETER_TYPE_ID)
          elem.value = this.errors.waistPerimeter.length === 0 ? value : null
        } else {
          this.measurement.measurements.push({
            value: this.errors.waistPerimeter.length === 0 ? value : null,
            typeId: WAIST_PERIMETER_TYPE_ID
          })
        }
      this.checkCanSubmit()
    },
    "form.abdomenPerimeter": function(value) {
      if(value !== '' && (value < 1 || value > 500)) {
        this.errors.abdomenPerimeter = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
      }
      else {
        this.errors.abdomenPerimeter = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === ABDOMEN_PERIMETER_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === ABDOMEN_PERIMETER_TYPE_ID)
        elem.value = this.errors.abdomenPerimeter.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.abdomenPerimeter.length === 0 ? value : null,
          typeId: ABDOMEN_PERIMETER_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.chestPerimeter": function(value) {
      if(value !== '' && (value < 1 || value > 500)) {
        this.errors.chestPerimeter = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
      }
      else {
        this.errors.chestPerimeter = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === CHEST_PERIMETER_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === CHEST_PERIMETER_TYPE_ID)
        elem.value = this.errors.chestPerimeter.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.chestPerimeter.length === 0 ? value : null,
          typeId: CHEST_PERIMETER_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.relaxedArmPerimeter": function(value) {
      if(value !== '' && (value < 1 || value > 500)) {
        this.errors.relaxedArmPerimeter = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
      }
      else {
        this.errors.relaxedArmPerimeter = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === RELAXED_ARM_PERIMETER_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === RELAXED_ARM_PERIMETER_TYPE_ID)
        elem.value = this.errors.relaxedArmPerimeter.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.relaxedArmPerimeter.length === 0 ? value : null,
          typeId: RELAXED_ARM_PERIMETER_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.thighPerimeter": function(value) {
      if(value !== '' && (value < 1 || value > 500)) {
        this.errors.thighPerimeter = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
      }
      else {
        this.errors.thighPerimeter = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === THIGH_PERIMETER_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === THIGH_PERIMETER_TYPE_ID)
        elem.value = this.errors.thighPerimeter.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.thighPerimeter.length === 0 ? value : null,
          typeId: THIGH_PERIMETER_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.calfPerimeter": function(value) {
      if(value !== '' && (value < 1 || value > 500)) {
        this.errors.calfPerimeter = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 500})]
      }
      else {
        this.errors.calfPerimeter = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === CALF_PERIMETER_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === CALF_PERIMETER_TYPE_ID)
        elem.value = this.errors.calfPerimeter.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.calfPerimeter.length === 0 ? value : null,
          typeId: CALF_PERIMETER_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
